<template>
  <div class="hello" style="background-color: #f0f3f7; min-height: 100vh">
    <div v-if="isDev">
      <button style="color: #000" @click="quitLoginFn">退出登录</button>
    </div>
    <div>
      <div
        style="
          background-color: #ffffff;
          padding: 10px 10px 5px 10px;
          border-radius: 0px;
        "
      >
        <!-- <van-swipe v-if="swipeImages.length > 0" :autoplay="3000">
          <van-swipe-item v-for="(item, index) in swipeImages" :key="index">
            <img :src="imgUrl + item.url" style="width:100%; height:100%;" />
          </van-swipe-item>
        </van-swipe> -->
        <div style="width: 100%; height: 200px">
          <img
            :src="require('../assets/picture/home6.jpg')"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>

      <div style="padding: 0 0px">
        <div
          style="
            background-color: #ffffff;
            padding: 2px;
            margin: 5px 5px 0 5px;
            border-radius: 5px;
          "
        >
          <van-row
            gutter="6"
            type="flex"
            justify="center"
            style="margin-top: 5px; padding: 0 5px"
          >
            <van-col
              span="6"
              v-for="(item, index) in imagesflow2"
              :key="index"
              style="margin-bottom: 10px"
            >
              <van-image
                width="65%"
                :src="item.img"
                @click="flow1ClickMethod(item)"
              />
              <div style="color: #333; font-size: 13px">{{ item.name }}</div>
            </van-col>
          </van-row>
        </div>
      </div>

      <div style="padding: 0 5px; position: relative">
        <div
          style="
            background-color: #ffffff;
            padding: 10px 10px 5px 10px;
            margin-top: 5px;
            border-radius: 5px;
          "
        >
          <van-image :src="background2" style="width: 100%" radius="10">
          </van-image>
          <van-row
            gutter="25"
            type="flex"
            justify="center"
            style="flex-wrap: wrap; position: absolute; top: 5%"
          >
            <van-col
              span="7"
              v-for="(item, index) in imagesflow3"
              :key="index"
              style="margin-top: 10%"
            >
              <van-image
                width="100%"
                radius="10px"
                :src="item.img"
                @click="flow3ClickMethod(item)"
              />
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div style="height: 100px"></div>
  </div>
</template>

<script>
import { Notify } from 'vant'
import crudUser from '../api/user'
import { ApiGetAllImg } from '@/api/zdqd.js'
import { setMd } from '@/utils/maidian/zzdmd.js'
import dd from 'gdt-jsapi'
import { Toast } from 'vant'
export default {
  name: 'HelloWorld',
  data() {
    return {
      isDev: false,
      swipeImages: [],
      imgUrl: '',
      background2: require('../assets/picture/f3-16.png'),
      imagesflow2: [
        {
          img: require('../assets/picture/11.png'),
          url: '/ztjz',
          name: '总体进度',
        },
        {
          img: require('../assets/picture/33.png'),
          url: '/zbjb',
          name: '工作专报',
        },
        {
          img: require('../assets/picture/22.png'),
          url: '/lst',
          name: '绿榜项目',
        },
        {
          img: require('../assets/picture/44.png'),
          url: '/xcbd',
          name: '宣传报道',
        },
        // {
        //   img: require('../assets/picture/55.png'),
        //   url: '/jjzb',
        //   name: '经济指标'
        // },
        // {
        //   img: require('../assets/picture/66.png'),
        //   url: '/cgk',
        //   name: '"6+2"指标'
        // },
        // {
        //   img: require('../assets/picture/77.png'),
        //   url: '/zsyz',
        //   name: '招商引资'
        // },
        // {
        //   img: require('../assets/picture/88.png'),
        //   url: '/bdql',
        //   name: '拔钉清零'
        // }
      ],
      imagesflow3: [
        {
          img: require('../assets/picture/f3-10.png'),
          url: '/ggcx',
          key: 1,
          name: '产业升级',
        },
        {
          img: require('../assets/picture/f3-11.png'),
          url: '/ggcx',
          key: 2,
          name: '项目提速',
        },
        {
          img: require('../assets/picture/f3-12.png'),
          url: '/ggcx',
          key: 3,
          name: '改革创新',
        },
        {
          img: require('../assets/picture/f3-13.png'),
          url: '/ggcx',
          key: 4,
          name: '共富先行',
        },
        {
          img: require('../assets/picture/f3-14.png'),
          url: '/ggcx',
          key: 5,
          name: '治理破难',
        },
        {
          img: require('../assets/picture/f3-15.png'),
          url: '/ggcx',
          key: 6,
          name: '党建引领',
        },
      ],
      // 登录的token
      // token: ''
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     if (process.env.NODE_ENV == 'production') {
  //       Toast.loading({
  //         duration: 0,
  //         mask: true,
  //         message: '登录中...',
  //         forbidClick: true
  //       })
  //       dd.ready(() => {
  //         dd.getAuthCode({})
  //           .then(res => {
  //             crudUser.getInfo(res.code).then(res1 => {
  //               sessionStorage.setItem('token', res1.data.token)
  //               sessionStorage.setItem('accountid', res1.data.accountid)
  //               Toast.clear(true)
  //               // 埋点
  //               let { id, title } = to.meta
  //               setMd(id, title, to.path)
  //             })
  //           })
  //           .catch(err => {})
  //       })
  //     }
  //   })
  // },
  created() {
    this.imgUrl = process.env.VUE_APP_BASE_API
    if (process.env.NODE_ENV == 'development') {
      this.isDev = true
    } else {
      this.isDev = false
    }
    // 获取轮播图图片
    ApiGetAllImg().then((res) => {
      this.swipeImages = res.data.filter((x) => x.type == 'appFile')
    })
  },
  methods: {
    quitLoginFn() {
      sessionStorage.removeItem('token')
      this.$router.replace('/login')
    },
    flow1ClickMethod(item) {
      this.$router.push({
        //核心语句
        path: item.url, //跳转的路径
        query: {},
      })
    },
    flow3ClickMethod(item) {
      if (item.url == '' || item.url == undefined) {
        Notify({
          message: '功能模块建设中...',
          duration: 1000,
          background: '#1989fa',
        })
      } else {
        this.$router.push({
          //核心语句
          path: item.url, //跳转的路径
          query: { key: item.key, name: item.name },
        })
      }
    },
  },
}
</script>
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-notice-bar >>> .van-icon__image {
  width: 4em !important;
  margin-right: 1rem;
}
.homeImage {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue